import { render, staticRenderFns } from "./ReferenceValues.vue?vue&type=template&id=1a596f87&scoped=true"
import script from "./ReferenceValues.vue?vue&type=script&lang=js"
export * from "./ReferenceValues.vue?vue&type=script&lang=js"
import style0 from "./ReferenceValues.vue?vue&type=style&index=0&id=1a596f87&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a596f87",
  null
  
)

export default component.exports